import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';

import { ComplianceTypes } from '@/constants';
import {
  selectEpisodeCompliance,
  useAppSelector,
  useFetchEpisodeScheduledArchivalDateQuery,
} from '@/store';

export const ArchivalDisclaimer = ({ episodeId }: { episodeId: string }) => {
  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, episodeId),
  );

  const { data: scheduledArchivalDate } =
    useFetchEpisodeScheduledArchivalDateQuery({
      episodeId,
    });

  if (!scheduledArchivalDate) return null;

  const daysUntilArchival = Math.ceil(
    (new Date(scheduledArchivalDate).getTime() - Date.now()) /
      (1000 * 60 * 60 * 24),
  );

  if (daysUntilArchival > 90 || daysUntilArchival <= 0) return null;

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: '#FBE4B366',
        borderRadius: 4,
      }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Leaving in {daysUntilArchival} day{daysUntilArchival === 1 ? '' : 's'}
      </Typography>
      <Typography variant="body2">
        This episode will be archived on{' '}
        <b>{format(new Date(scheduledArchivalDate), 'MMMM dd, yyyy')}</b>. To
        receive credit, please ensure you complete the episode and{' '}
        {compliance === ComplianceTypes.CPD
          ? 'quizzes'
          : 'qualified assessment'}{' '}
        before then.
      </Typography>
    </Box>
  );
};
